'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useRef, useEffect } from 'react';
import Button from '../Button/index.js';
import CopyIcon from '../Images/CopyIcon/index.js';
import FacebookIcon from '../Images/FacebookIcon/index.js';
import LinkedInIcon from '../Images/LinkedInIcon/index.js';
import ShareIcon from '../Images/ShareIcon/index.js';
import SlideModal from '../Modal/SlideModal.js';
import { ELanguage } from '../Utils/constants.js';
import { ShareButtonWrapper, ShareDropdown, ShareWrapper, ShareListUl, ShareText, ShareItem, ShareItemIcon } from './ShareButton.css.js';
import translations from './translations.js';

var ShareButton = function (props) {
    var _a;
    var langCode = props.langCode, buttonStyle = props.buttonStyle, _b = props.position, position = _b === void 0 ? 'left' : _b;
    var _c = useState(false), isShow = _c[0], setShowDropdown = _c[1];
    var _d = useState(false), isMounted = _d[0], setMount = _d[1];
    var dropdownRef = useRef(null);
    var isMobile = typeof window !== 'undefined' ? window.innerWidth < 768 : false;
    // Get page title and page URL
    var currentHref = '';
    var pageTitle = '';
    if (typeof window !== 'undefined') {
        pageTitle = encodeURIComponent(((_a = document.querySelector('meta[property="og:title"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) || '');
        currentHref = encodeURIComponent(window.location.href);
    }
    var facebookShareLink = "https://www.facebook.com/sharer.php?t=".concat(pageTitle, "&u=").concat(currentHref);
    // const twitterShareLink = `https://twitter.com/intent/tweet?text=${pageTitle}&url=${currentHref}`
    var linkedinShareLink = "https://www.linkedin.com/shareArticle?title=".concat(pageTitle, "&url=").concat(currentHref);
    var t = function (text) {
        if (langCode === ELanguage.EN) {
            return text;
        }
        else {
            return translations[text];
        }
    };
    var handleClickShare = function (e) {
        e.stopPropagation();
        var isHideDropdown = !isShow;
        if (isHideDropdown) {
            setMount(true);
        }
        setShowDropdown(isHideDropdown);
    };
    var onAnimationEnd = function () {
        if (!isShow)
            setMount(false);
    };
    var isClickOutside = function (event, ref, isReactRef) {
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && isReactRef) {
            if (ref.current.contains(event.target))
                return false;
        }
        else if (!isReactRef && ref) {
            if (ref.contains(event.target))
                return false;
        }
        return true;
    };
    var openInNewWindow = function (link) {
        var left = window.innerWidth / 2 - 720 / 2;
        var top = window.innerHeight / 2 - 480 / 2;
        window.open(link, '_blank', "toolbar=no,\n                    location=no,\n                    status=no,\n                    menubar=no,\n                    scrollbars=yes,\n                    resizable=yes,\n                    width=720,\n                    height=480\n                    top=".concat(top, ",\n                    left=").concat(left, "\n                    "));
    };
    var handleOnClickFacebook = function () {
        openInNewWindow(facebookShareLink);
        setShowDropdown(false);
    };
    // const handleOnClickZalo = () => {
    //     // TODO: Handle click zalo share
    //     setShowDropdown(false)
    // }
    var handleOnClickLinkedIn = function () {
        openInNewWindow(linkedinShareLink);
        setShowDropdown(false);
    };
    var handleOnClickCopyLink = function () {
        if (typeof window === 'undefined') {
            return;
        }
        if (!navigator.clipboard) {
            // Create a temporary textarea element
            var textArea = document.createElement('textarea');
            textArea.id = 'copyTextArea';
            textArea.style.position = 'absolute';
            textArea.style.opacity = '0';
            document.body.append(textArea);
            // Set the content of the area with the current HREF
            textArea.innerHTML = window.location.href;
            // Copy the value of the textarea
            textArea.select();
            document.execCommand('copy');
            textArea.remove();
        }
        else {
            navigator.clipboard.writeText(window.location.href);
        }
        setShowDropdown(false);
    };
    useEffect(function () {
        var handleClickOnScreen = function (e) {
            var isClickOutsideDropdown = isClickOutside(e, dropdownRef, true);
            if (isClickOutsideDropdown) {
                setShowDropdown(false);
            }
        };
        if (typeof window !== undefined) {
            document.addEventListener('click', handleClickOnScreen);
        }
        // on component did unmount
        return function () {
            if (typeof window !== undefined) {
                document.removeEventListener('click', handleClickOnScreen);
            }
        };
    }, []);
    var renderShareList = function () {
        return (React__default.createElement(ShareListUl, { isMobile: isMobile },
            !isMobile && React__default.createElement(ShareText, null, t('Share to...')),
            React__default.createElement(ShareItem, { onClick: handleOnClickFacebook, isMobile: isMobile },
                React__default.createElement(ShareItemIcon, null,
                    React__default.createElement(FacebookIcon, null)),
                t('Share by '),
                " Facebook"),
            React__default.createElement(ShareItem, { onClick: handleOnClickLinkedIn, isMobile: isMobile },
                React__default.createElement(ShareItemIcon, null,
                    React__default.createElement(LinkedInIcon, null)),
                t('Share by '),
                " LinkedIn"),
            React__default.createElement(ShareItem, { onClick: handleOnClickCopyLink, isMobile: isMobile },
                React__default.createElement(ShareItemIcon, null,
                    React__default.createElement(CopyIcon, null)),
                t('Copy link'))));
    };
    return (React__default.createElement(ShareButtonWrapper, null,
        React__default.createElement(Button, { type: 'default', onClick: handleClickShare, style: __assign({ padding: '8px 12px' }, buttonStyle) },
            React__default.createElement(ShareIcon, null)),
        isMounted && !isMobile && (React__default.createElement(ShareDropdown, { position: position },
            React__default.createElement(ShareWrapper, { isShow: isShow, onAnimationEnd: onAnimationEnd, ref: dropdownRef }, renderShareList()))),
        isMounted && isMobile && (React__default.createElement(SlideModal, { isOpen: isShow, title: t('Share to...'), onBack: function () { return setShowDropdown(false); } }, renderShareList()))));
};

export { ShareButton as default };
//# sourceMappingURL=index.js.map
